import { getFailedState } from './../../utils/store';
import { GET_USER, SIGN_OUT } from '../actions/types';
import { AuthState } from './types/auth-state';
import { UserActions } from '../actions/user-actions';
import {
  getInitialState,
  getRequestingState,
  getSuccessState,
} from '@utils/store';

const initialState = {
  data: {},
  request: false,
};

const UserReducer = (state = initialState, action: UserActions): AuthState => {
  switch (action.type) {
    case GET_USER.GET_USER_REQUEST:
      return {
        ...getRequestingState({ data: {} }),
      };

    case GET_USER.GET_USER_SUCCESS: {
      const { payload } = action as any;

      return {
        ...getSuccessState({ data: payload.data }),
      };
    }

    case GET_USER.GET_USER_FAILED:
      return {
        ...getFailedState(),
      };

    case SIGN_OUT.SIGN_OUT_REQUEST:
      return {
        ...getInitialState({ data: {} }),
      };

    default:
      return state;
  }
};

export default UserReducer;
